import hiw2 from "../../public/images/HIBRO_HOWITWORKS-02.webp";
import Image from "next/image";

const titleCat = {
  "a27d397a-b0dc-40d6-b28c-0b08c70bf01c":
    "จบทุกปัญหาหย่อนสมรรถภาพทางเพศ นกเขาไม่ขัน  เพียงพบผู้เชี่ยวชาญในการดูแลสุขภาพแบบส่วนตัว",
  "c823e98b-62e9-4fd7-8a83-c47296f66184":
    "จบทุกปัญหาหลั่งเร็ว ล่มปากอ่าว เพียงพบผู้เชี่ยวชาญในการดูแลสุขภาพแบบส่วนตัว",
  "ffe218b6-65db-436e-b193-b2147e5aa570":
    "จบทุกปัญหาศีรษะล้าน ผมร่วง ผมบาง เพียงพบผู้เชี่ยวชาญในการดูแลสุขภาพแบบส่วนตัว",
};
const treatmentCategoryMap = {
  "9b596a76-a677-49ee-990b-7dc9e31b8644": "pc",
  "ffe218b6-65db-436e-b193-b2147e5aa570": "hl",
  "a27d397a-b0dc-40d6-b28c-0b08c70bf01c": "ed",
  "c823e98b-62e9-4fd7-8a83-c47296f66184": "pe",
};

const CallToAction = ({ item, router }) => {
  return (
    <div id="category-block">
      <div className="flex flex-row md:space-x-6 border-b py-4 md:pt-0 md:pb-4">
        <Image
          src={hiw2}
          alt="how-it-work"
          title="how-it-work"
          className="hidden md:block w-1/3 h-auto object-contain"
        />
        <div className="flex-auto text-center md:text-left flex flex-col space-y-4 md:space-y-6 justify-center">
          <p className="text-2xl md:text-3xl">Read enough?</p>
          <p className="text-thai text-lg md:text-xl">
            {titleCat[item?.categoryIDs && item?.categoryIDs[0]]}
          </p>
          <div
            className="flex"
            onClick={() => {
              router.push(
                `/treatment?cat=${treatmentCategoryMap[item.categoryIDs[0]]}`
              );
            }}
          >
            <div className="min-width cursor-pointer px-4 rounded-[8px] bg-[#2A2A2A] row-center text-white bg-green h-16 mb-2 flex items-center justify-center">
              <p className="text-base">Start treatment</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
